import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import Select from 'components/Select'
import {
  CRITERIA_STATUS,
  CRITERIA_STATUS_FILTER_ALL,
  TAXONOMIC_GROUP_FILTER_ALL,
  UNDER_ASSESSMENT_FILTER
} from 'utils/speciesCriteriaMet'
import { getTaxonomicGroupOptions } from 'utils/speciesCriteriaMet/filterSpecies'
import { SpeciesFilterField } from './style'

export const TaxonomicGroupFilter = ({ species, value, onChange }) => {
  const intl = useIntl()
  const options = useMemo(() => {
    const groups = getTaxonomicGroupOptions(species)

    return [
      { label: intl.formatMessage({ id: 'speciesCriteriaMetAllGroups' }), value: TAXONOMIC_GROUP_FILTER_ALL },
      ...groups.map((group) => ({ label: group, value: group }))
    ]
  }, [intl, species])

  return (
    <SpeciesFilterField>
      <Select
        value={options.find((option) => option.value === value) || options[0]}
        onChange={(selected) => onChange(selected?.value || TAXONOMIC_GROUP_FILTER_ALL)}
        options={options}
        label="taxonGroup"
        height="42px"
        marginBottom="0"
        marginBottomLabel="6px"
        dataTest="species-criteria-met-taxonomic-group-filter"
      />
    </SpeciesFilterField>
  )
}

export const CriteriaStatusFilter = ({ value, onChange }) => {
  const intl = useIntl()
  const options = useMemo(() => ([
    { label: intl.formatMessage({ id: 'all' }), value: CRITERIA_STATUS_FILTER_ALL },
    { label: intl.formatMessage({ id: 'criteriaStatusQualifyingTrigger' }), value: CRITERIA_STATUS.QUALIFYING_TRIGGER },
    { label: intl.formatMessage({ id: 'criteriaStatusDisqualifiedTrigger' }), value: CRITERIA_STATUS.DISQUALIFIED_TRIGGER },
    { label: intl.formatMessage({ id: 'criteriaStatusLegacyTrigger' }), value: CRITERIA_STATUS.LEGACY_TRIGGER },
    { label: intl.formatMessage({ id: 'criteriaStatusNonQualifying' }), value: CRITERIA_STATUS.NON_QUALIFYING }
  ]), [intl])

  return (
    <SpeciesFilterField>
      <Select
        value={options.find((option) => option.value === value) || options[0]}
        onChange={(selected) => onChange(selected?.value || CRITERIA_STATUS_FILTER_ALL)}
        options={options}
        label="criteriaStatus"
        height="42px"
        marginBottom="0"
        marginBottomLabel="6px"
        dataTest="species-criteria-met-criteria-status-filter"
      />
    </SpeciesFilterField>
  )
}

export const UnderAssessmentFilter = ({ value, onChange }) => {
  const intl = useIntl()
  const options = useMemo(() => ([
    { label: intl.formatMessage({ id: 'all' }), value: UNDER_ASSESSMENT_FILTER.ALL },
    { label: intl.formatMessage({ id: 'underAssessment' }), value: UNDER_ASSESSMENT_FILTER.UNDER },
    { label: intl.formatMessage({ id: 'notUnderAssessment' }), value: UNDER_ASSESSMENT_FILTER.NOT_UNDER }
  ]), [intl])

  return (
    <SpeciesFilterField>
      <Select
        value={options.find((option) => option.value === value) || options[0]}
        onChange={(selected) => onChange(selected?.value || UNDER_ASSESSMENT_FILTER.ALL)}
        options={options}
        label="underAssessment"
        height="42px"
        marginBottom="0"
        marginBottomLabel="6px"
        dataTest="species-criteria-met-under-assessment-filter"
      />
    </SpeciesFilterField>
  )
}

TaxonomicGroupFilter.propTypes = {
  species: PropTypes.arrayOf(PropTypes.shape({
    taxonomicGroup: PropTypes.string,
    taxonGroup: PropTypes.string
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

CriteriaStatusFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

UnderAssessmentFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}
